import MediaCarousel from './MediaCarousel';

export default MediaCarousel;
